var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 186,
    viewBox: "0 0 182 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 182,
    height: 186
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.231 52.0487L95.4805 60.4043L142.22 61.8839L107.231 52.0487Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4805 114.281H142.22V61.8839L95.4805 60.4043V114.281Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.231 52.0487L147.616 27.504L142.22 61.8839L107.231 52.0487Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.22 114.281L145.614 89.1268L142.22 61.8839V114.281Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.616 27.504L177.47 57.0098L175.12 89.562L142.22 61.8839L147.616 27.504Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.22 114.281L175.12 89.562L145.614 89.1268L142.22 114.281Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.22 61.8839L175.12 89.562L145.614 89.1268L142.22 61.8839Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.22 114.281L147.877 153.013L177.47 127.511L175.12 89.562L142.22 114.281Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.47 57.0098L181.387 74.2433L175.991 77.8119L177.47 57.0098Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.426 110.799L181.387 115.151V74.2433L175.991 77.8119L175.12 89.562L176.426 110.799Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.47 127.511L181.387 115.151L176.426 110.799L177.47 127.511Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.877 153.013L154.057 164.763L117.936 184.607L107.231 175.904L147.877 153.013Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.47 127.511L154.057 164.763L152.403 149.096L177.47 127.511Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.877 153.013L152.403 149.096L154.057 164.763L147.877 153.013Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4805 114.281L107.231 129.425L142.22 114.281H95.4805Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.877 153.013L107.231 129.425L107.231 175.904L147.877 153.013Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.22 114.281L147.877 153.013L107.231 129.425L142.22 114.281Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4805 114.281L107.231 129.425L74.2434 154.231L95.4805 114.281Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.231 175.904L74.2434 154.231L107.231 129.425L107.231 175.904Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4805 114.281L49.4375 88.0824L30.5503 127.511L74.2434 154.231L95.4805 114.281Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.231 175.904L74.2434 186L42.0394 166.504L74.2434 154.231L107.231 175.904Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.936 184.607L74.2434 186L107.231 175.904L117.936 184.607Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5503 127.511L2.95931 115.151L16.7983 151.446L42.0394 166.504L30.5503 127.511Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2434 154.231L54.3987 142.133L42.0394 166.504L74.2434 154.231Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5503 127.511L54.3987 142.133L42.0394 166.504L30.5503 127.511Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2064 88.0824L95.4805 114.281L49.4375 88.0824H81.2064Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4805 60.4043V114.281L81.2064 88.0824L95.4805 60.4043Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4375 88.0824L95.4805 60.4043L81.2064 88.0824H49.4375Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95931 115.151L42.0393 91.1287L30.5503 127.511L2.95931 115.151Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4375 88.0824L30.5503 51.0042L74.2433 24.4577L95.4805 60.4043L49.4375 88.0824Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5503 127.511L49.4375 88.0824L42.0393 91.1287L30.5503 127.511Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5503 51.0042L49.4375 88.0824L42.0393 91.1287L30.5503 51.0042Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95931 115.151V69.4563L42.0393 91.1287L2.95931 115.151Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5503 51.0042L2.95931 69.4563L42.0393 91.1287L30.5503 51.0042Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95931 115.151L0 114.281L16.7983 151.446L2.95931 115.151Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.95931 69.4563L0 75.723V114.281L2.95931 115.151V69.4563Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5503 51.0042L42.0393 16.2761L15.8409 35.5115L2.95931 69.4563L30.5503 51.0042Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 75.723L2.95931 69.4563L15.8409 35.5115L0 75.723Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5503 51.0042L53.7024 36.9041L42.0393 16.2761L30.5503 51.0042Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2433 24.4577L42.0393 16.2761L53.7024 36.9041L74.2433 24.4577Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4805 60.4043L107.231 52.0487L74.2433 24.4577L95.4805 60.4043Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0393 16.2761L73.46 0L107.231 5.91858L74.2433 24.4577L42.0393 16.2761Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.616 27.504L107.231 5.91858L107.231 52.0487L147.616 27.504Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2433 24.4577L107.231 5.91858L107.231 52.0487L74.2433 24.4577Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.47 57.0098L153.796 21.6724L152.752 32.6392L177.47 57.0098Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.616 27.504L153.796 21.6724L152.752 32.6392L147.616 27.504Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.231 5.91858L117.327 2.95928L153.796 21.6724L147.616 27.504L107.231 5.91858Z",
    fill: "#E5E3DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.46 0L117.327 2.95928L107.231 5.91858L73.46 0Z",
    fill: "#E5E3DC"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.231 52.0486L95.4805 60.4043L142.22 61.8839L107.231 52.0486Z",
    fill: "#EDECE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4805 114.281H142.22V61.8839L95.4805 60.4043V114.281Z",
    fill: "#CFCEC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.231 52.0487L147.616 27.504L142.22 61.8839L107.231 52.0487Z",
    fill: "#B4B4B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.22 114.281L145.614 89.1268L142.22 61.884V114.281Z",
    fill: "#EEEDE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.616 27.504L177.47 57.0098L175.12 89.562L142.22 61.8839L147.616 27.504Z",
    fill: "#F1F1E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M142.22 114.281L175.12 89.562L145.614 89.1268L142.22 114.281Z",
    fill: "#E1E0D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.22 61.884L175.12 89.562L145.614 89.1268L142.22 61.884Z",
    fill: "#848380"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.22 114.281L147.877 153.013L177.47 127.511L175.12 89.562L142.22 114.281Z",
    fill: "#D3D3C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.47 57.0098L181.387 74.2433L175.991 77.8119L177.47 57.0098Z",
    fill: "#B5B4AA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M176.426 110.799L181.387 115.151V74.2433L175.99 77.8119L175.12 89.562L176.426 110.799Z",
    fill: "#DCDBD1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.47 127.511L181.387 115.151L176.426 110.799L177.47 127.511Z",
    fill: "#F5F4EB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.877 153.013L154.057 164.763L117.936 184.607L107.231 175.904L147.877 153.013Z",
    fill: "#6B6A65"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.47 127.51L154.057 164.763L152.403 149.096L177.47 127.51Z",
    fill: "#7B7A76"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.877 153.013L152.403 149.096L154.057 164.763L147.877 153.013Z",
    fill: "#ECECE0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4805 114.281L107.231 129.425L142.22 114.281H95.4805Z",
    fill: "#3A3A3A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M147.877 153.013L107.231 129.425V175.904L147.877 153.013Z",
    fill: "#898987"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M142.22 114.281L147.877 153.013L107.231 129.425L142.22 114.281Z",
    fill: "#5F5F5F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4807 114.281L107.231 129.425L74.2434 154.231L95.4807 114.281Z",
    fill: "#A3A29A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.231 175.904L74.2434 154.231L107.231 129.425V175.904Z",
    fill: "#C9C8C0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4806 114.281L49.4375 88.0823L30.5503 127.511L74.2433 154.231L95.4806 114.281Z",
    fill: "#878787"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M107.231 175.904L74.2433 186L42.0393 166.504L74.2433 154.231L107.231 175.904Z",
    fill: "#525252"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M117.936 184.607L74.2434 186L107.231 175.904L117.936 184.607Z",
    fill: "#434343"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5502 127.511L2.95923 115.151L16.7983 151.446L42.0392 166.503L30.5502 127.511Z",
    fill: "#737373"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2433 154.231L54.3987 142.133L42.0393 166.504L74.2433 154.231Z",
    fill: "#808080"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5503 127.51L54.3987 142.133L42.0393 166.503L30.5503 127.51Z",
    fill: "#585858"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2063 88.0823L95.4805 114.281L49.4375 88.0823H81.2063Z",
    fill: "#BFC0B9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4805 60.4043V114.281L81.2063 88.0823L95.4805 60.4043Z",
    fill: "#8C8C8C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4375 88.0823L95.4805 60.4043L81.2063 88.0823H49.4375Z",
    fill: "#6B6B6B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95923 115.151L42.0392 91.1287L30.5502 127.511L2.95923 115.151Z",
    fill: "#A7A7A7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4375 88.0823L30.5503 51.0042L74.2433 24.4576L95.4806 60.4043L49.4375 88.0823Z",
    fill: "#B5B6B0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5503 127.511L49.4375 88.0823L42.0393 91.1287L30.5503 127.511Z",
    fill: "#939393"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5503 51.0042L49.4375 88.0824L42.0393 91.1287L30.5503 51.0042Z",
    fill: "#767676"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95923 115.151V69.4562L42.0392 91.1287L2.95923 115.151Z",
    fill: "#8C8C8C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5502 51.0042L2.95923 69.4563L42.0392 91.1287L30.5502 51.0042Z",
    fill: "#686868"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95929 115.151L0 114.281L16.7983 151.446L2.95929 115.151Z",
    fill: "#828282"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95929 69.4562L0 75.723V114.281L2.95929 115.151V69.4562Z",
    fill: "#8A898A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5502 51.0042L42.0392 16.2761L15.8408 35.5114L2.95923 69.4562L30.5502 51.0042Z",
    fill: "#A7A7A7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 75.723L2.95929 69.4563L15.8409 35.5115L0 75.723Z",
    fill: "#909090"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5503 51.0042L53.7024 36.904L42.0393 16.2761L30.5503 51.0042Z",
    fill: "#C9CAC3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2433 24.4576L42.0393 16.2761L53.7024 36.904L74.2433 24.4576Z",
    fill: "#919191"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4807 60.4043L107.231 52.0487L74.2434 24.4576L95.4807 60.4043Z",
    fill: "#FAF9F2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0393 16.2761L73.46 0L107.231 5.91858L74.2433 24.4577L42.0393 16.2761Z",
    fill: "#DBD9D4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M147.616 27.504L107.231 5.91858V52.0487L147.616 27.504Z",
    fill: "#A1A2A0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2434 24.4577L107.231 5.91858V52.0487L74.2434 24.4577Z",
    fill: "#E0E0D6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M177.47 57.0098L153.796 21.6724L152.751 32.6392L177.47 57.0098Z",
    fill: "#DFDED6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M147.616 27.504L153.796 21.6724L152.751 32.6392L147.616 27.504Z",
    fill: "#E9E9DF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M107.231 5.91858L117.327 2.95929L153.796 21.6724L147.616 27.504L107.231 5.91858Z",
    fill: "#F5F5ED"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M73.46 0L117.327 2.95929L107.231 5.91858L73.46 0Z",
    fill: "#E5E3DC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 186,
    fill: "#FBC016",
    fillOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel3);
export default __webpack_public_path__ + "static/media/level3.d3e29e1b07b3ecbe26331186f234c3ec.svg";
export { ForwardRef as ReactComponent };